import { MakeCall, MakeCallPromise } from 'ha/services/apiV2/createMakeCall';
import { MyUserInfoApiV2, UserInformation } from './types/UserInformation';
import { APIV2_URL } from './constants';

interface Query {
  expand: string;
}

const getUserInformation = (makeCall: MakeCall) => {
  function getUserInformationCall(
    id: 'me',
    query?: Query,
  ): MakeCallPromise<MyUserInfoApiV2>;
  function getUserInformationCall(
    id: number,
    query?: Query,
  ): MakeCallPromise<UserInformation>;
  function getUserInformationCall(id: number | 'me' = 'me', query?: Query) {
    return makeCall('GET', `${APIV2_URL}/user/${id}/information`, { query });
  }

  return getUserInformationCall;
};

export default getUserInformation;
